module.exports = __webpack_public_path__ + "static/img/1.d393dd4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/challenge/1.png
// module id = su2n
// module chunks = 1